import type {
	BaseItemSchema,
	ChecklistIntroItem,
	FullTestFormatIntroItem,
	MicCheckIntroItem,
	PartTestFormatIntroItem,
	ReadyToStartIntroItem,
} from "@memorang/types";

export const isIntroScreen = (item: BaseItemSchema | undefined): boolean => {
	return item?.metadata?.type === "INTRO_SCREEN";
};

// PART_TEST_FORMAT is the only intro screen that keeps the app bar (and its timer).
export const isIntroScreenWithoutAppBar = (
	item: BaseItemSchema | undefined,
): boolean => {
	return (
		isIntroScreen(item) && item?.metadata?.screenType !== "PART_TEST_FORMAT"
	);
};

export const isPartTestFormatIntroItem = (
	item: BaseItemSchema,
): item is PartTestFormatIntroItem => {
	return item.metadata?.screenType === "PART_TEST_FORMAT";
};

export const isChecklistIntroItem = (
	item: BaseItemSchema,
): item is ChecklistIntroItem => {
	return item.metadata?.screenType === "CHECKLIST";
};

export const isMicCheckIntroItem = (
	item: BaseItemSchema,
): item is MicCheckIntroItem => {
	return item.metadata?.screenType === "MIC_CHECK";
};

export const isFullTestFormatIntroItem = (
	item: BaseItemSchema,
): item is FullTestFormatIntroItem => {
	return item.metadata?.screenType === "FULL_TEST_FORMAT";
};

export const isReadyToStartIntroItem = (
	item: BaseItemSchema,
): item is ReadyToStartIntroItem => {
	return item.metadata?.screenType === "READY_TO_START";
};
